import { CartDetails, getCartDetails } from "../lib/cart/CartDetails";
import React, { createContext, useEffect, useState } from "react";

export const CartContext = createContext({
  cartDetails: null as CartDetails | null,
  propagateCartDetails: () => {},
});

const CartContextProvider = (props) => {
  const [cartDetails, setCartDetails] = useState(null as CartDetails | null);

  const propagateCartDetails = () => {
    setCartDetails(getCartDetails());
  };

  useEffect(() => {
    setCartDetails(getCartDetails());
  }, []);

  return (
    <CartContext.Provider
      value={{
        cartDetails,
        propagateCartDetails,
      }}
    >
      {props.children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;
